import { XMarkIcon } from "@heroicons/react/24/outline";
import BasicButton from "components/buttons/Basic";
import BasicInput from "components/inputs/Basic";
import Select from "components/inputs/Select";
import { PricingInput } from "graphql/ssp/generated";
import { useRef } from "react";

type Props = {
  pricing: PricingInput;
  setPricing: React.Dispatch<React.SetStateAction<PricingInput>>;
};

export const TotalCondition: React.FC<Props> = ({ pricing, setPricing }) => {
  const formRef = useRef<HTMLFormElement>(null);
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between pb-2 mb-2 border-b ">
        <div>Spesa totale</div>
        <BasicButton
          className="py-1 text-sm text-gray-500 bg-gray-100 w-fit hover:bg-gray-200"
          onClick={() => {
            setPricing((prev) => {
              const { amount_1, condition_1, ...rest } = prev;
              return rest;
            });
            formRef.current?.reset();
          }}
        >
          Rimuovi condizione <XMarkIcon className="h-4" />
        </BasicButton>
      </div>
      <form
        className="grid w-fit grid-cols-[auto_auto_auto_auto] items-center gap-2 text-end"
        onSubmit={(e) => e.preventDefault()}
        ref={formRef}
      >
        <div className="text-gray-500">Condizione:</div>
        <Select
          defaultValue={pricing.condition_1 || ""}
          noDefault
          onChange={(e) =>
            setPricing((prev) => ({
              ...prev,
              condition_1: e.target.value || undefined,
            }))
          }
        >
          <option value={""}></option>
          <option value={"Maggiore"}>Maggiore di</option>
          <option value={"Minore"}>Minore di</option>
        </Select>

        <div className="text-gray-500">Prezzo:</div>
        <BasicInput
          defaultValue={pricing.amount_1 || undefined}
          onChange={(e) =>
            setPricing((prev) => ({
              ...prev,
              amount_1: Number(e.target.value) || undefined,
            }))
          }
          type="number"
        />
      </form>
    </div>
  );
};
export default TotalCondition;
